export default "__VITE_ASSET__dd96613a__"